const setting = {
  url: "https://magzine-be.onrender.com" || "http://127.0.0.1:9000",
};

export default setting;
